// extracted by mini-css-extract-plugin
export var fullWidthButton = "_fo-0";